import { Box, theme } from "@aksara-ui/react";
import React from "react";
import styled from "styled-components";

const SelectInput = styled.select<{
  error?: boolean;
}>`
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  border-radius: 4px;
  color: #313f4e;
  border-color: ${(props) => (!props.error ? "#d7dbdf" : theme.colors.red07)};
  padding: 9px 16px;
  display: block;

  &:focus {
    outline: none;
    border-width: 2px;
    border-color: ${theme.colors.blue07};  }
`;

interface Item {
  label: string;
  value: string | number;
}

interface Props {
  items: Item[];
  handleChange?: (selected: string) => void;
  label?: string;
  value?: string | number;
  boxStyle?: object;
  error?: boolean;
}

const InputSelect: React.FC<Props> = ({
  label,
  value,
  boxStyle,
  items,
  handleChange,
  error,
}) => {
  const listOptions = items.map((el) => (
    <option key={el.value} value={el.value}>
      {el.label}
    </option>
  ));

  return (
    <Box style={boxStyle}>
      <SelectInput
        value={value}
        onChange={(e) => handleChange && handleChange(e.target.value)}
        error={error}
      >
        <option value="">Select {label}...</option>
        {listOptions}
      </SelectInput>
    </Box>
  );
};

export default InputSelect;
